import type { FaireProductEntity } from "../../entity_types/product";

export const p_4df3abffbk: FaireProductEntity = {
  token: "p_4df3abffbk",
  type: "product",
  name: "Lemon Ginger Herbal Tea, Organic, Kosher, Non ETO, Bulk 1 lb",
  brandToken: "b_5ashuqcsm4",
  brandName: "Frontier Co-op",
  imageUrl:
    "https://cdn.faire.com/fastly/f2424c083a93cadac5648310d230eeb219fed8cbe04e4c407f9193758a5a3435.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0ec4613d4aaed6662a7484b2d5b27da9ef2af5da3bba953999b8ac66092bbc4d.jpeg",
    "https://cdn.faire.com/fastly/ade1ddd75b22f86975d2d776838df6e5b05337c204e6d5a47e0f22c8162700bc.jpeg",
  ],
  priceDollars: 30.17,
  description:
    "Frontier Co-op® Organic Lemon Ginger Herbal Tea is USDA certified organic, kosher and non-irradiated, crafted with a bright blend of organic pure lemon oil, lemongrass, and subtle spices. This caffeine-free infusion offers a refreshing, zesty flavor that can be enjoyed hot or iced. Popular with natural grocers, tea blenders, cafés, and bulk refill programs, this bulk format supports a cost-effective way to stock a vibrant, high-demand herbal tea.\n\nResponsibly sourced lemon ginger herbal tea blend\nAvailable in bulk bags to support low-waste merchandising and cost-effective stocking\nEvery purchase supports our Well Earth program for sustainable and ethical sourcing\nRigorously tested for purity and freshness to ensure clean, unadulterated teas and herbs\nMember-owned co-op putting people and planet before profits\n\nBring Frontier Co-op® teas to your assortment to offer products that are flavorful, responsibly sourced and grounded in quality and integrity.",
  tags: [],
  msrpDollars: 60.33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:45.480Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
